import {connect} from 'react-redux';
import {ProtocolScene as Component} from './ProtocolScene';

import {
    //createPipette,
    //createSolution,
    //createTipBox,
    setUUID
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    //createPipette,
    //createSolution,
    //createTipBox,
    setUUID: (data) => {
      dispatch(setUUID(data))
    }
  };
}

export const ProtocolScene = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
